module.exports = __webpack_public_path__ + "images/ui-bg_glass_100_f6f6f6_1x400.png";